/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Type_Calisthenics_TermsInputs */

const en_service_type_calisthenics_terms = /** @type {(inputs: Service_Type_Calisthenics_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`street workout, bodyweight training, pull ups, bars`)
};

const pl_service_type_calisthenics_terms = /** @type {(inputs: Service_Type_Calisthenics_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`street workout, ćwiczenia z masą ciała, podciąganie, drążek, poręcze`)
};

/**
* | output |
* | --- |
* | "street workout, bodyweight training, pull ups, bars" |
*
* @param {Service_Type_Calisthenics_TermsInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const service_type_calisthenics_terms = /** @type {((inputs?: Service_Type_Calisthenics_TermsInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Type_Calisthenics_TermsInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_service_type_calisthenics_terms(inputs)
	return en_service_type_calisthenics_terms(inputs)
});